<script lang="ts">
  import { Dialog } from 'bits-ui';

  import SmallGhostButton from '@/ui/elements/buttons/SmallGhostButton.svelte';

  let { title }: { title: string } = $props();
</script>

<Dialog.Title
  class="flex  items-center justify-between border-b border-c-divider px-6 py-4 text-md font-semibold"
>
  {title}

  <Dialog.Close
    class="focus-visible:ring-foreground focus-visible:ring-offset-background focus-visible:outline-hidden rounded-md focus-visible:ring-2 focus-visible:ring-offset-2 active:scale-[0.98]"
  >
    <div>
      <SmallGhostButton icon="Close" label="Schließen" size="medium" tooltip={false} />
    </div>
  </Dialog.Close>
</Dialog.Title>
